import classNames from 'classnames';
import { LegendsEnum } from 'components/legends/legend-types';
import { FlexDivCenteredIcon } from 'utilities/svg-display/svg-layout';

interface LegendActionProps {
  label: string;
  onClick: (l: LegendsEnum) => void;
  // has specific action been selected
  active: LegendsEnum | undefined;
  icon: 'key' | 'filter';
  index: LegendsEnum;
}

export const LegendButton = ({ label, onClick, icon, index, active }: LegendActionProps) => {
  return (
    <button
      className={classNames(
        'u-mT-xs ZoomControl-btn zoom u-flex u-flexAlignItemsCenter u-flexJustifyCenter border-radius-xs map-control-shade u-isClickable',
        { 'icon-selected': active === index },
      )}
      aria-label={label}
      onClick={() => onClick(index)}
      title={label}
      role="button"
    >
      <div className="u-flex-1">
        <FlexDivCenteredIcon v={2} icon={active === index ? 'close' : icon} size={16} classes="svg--fill-inherit" />
      </div>
    </button>
  );
};
